import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, filter } from 'rxjs';
import { EBoard } from 'src/app/conf/device-models';
import { DeviceModel } from 'src/app/model/device-model';
import { DeviceStatus } from 'src/app/model/device-status';
import { AppState } from 'src/app/store/app.reducer';
import { selectCurrentDeviceStatus } from 'src/app/store/device/device.selector';

@Component({
	selector: 'app-device-state-progress',
	templateUrl: './device-state-progress.component.html',
	providers: [],
})

export class DeviceStateProgressComponent implements OnInit, OnDestroy {
	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription | undefined;

	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;

	deviceStatus: DeviceStatus = new DeviceStatus(0);
	deviceModel: DeviceModel = new DeviceModel();

	langSub: Subscription | undefined;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
	}

	ngOnInit(): void {
		this.subscribeAll();
	}

	subscribeAll() {
		this.deviceStatusSub = this.deviceStatus$.pipe(filter(ds => !!ds))
			.subscribe(currentDeviceStatus => {
				this.deviceStatus = currentDeviceStatus;
			}
			);
		this.deviceModelSub = this.store.select('device').subscribe(
			(device) => {
				if (device.currentDeviceModel) {
					this.deviceModel = device.currentDeviceModel;
				}
			}
		);
	}

	ngOnDestroy(): void {
		this.deviceStatusSub?.unsubscribe();
		this.deviceModelSub?.unsubscribe();
	}

	hasPercentageProgress(): boolean {
		if (this.deviceStatus.Percentage < 0) {
			return false;
		}
		if (this.deviceModel.BoardName != null) {
			return !(this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZBKE ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZBKN ||
				// this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZN7 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZN7V ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZBX7N ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZLJ24 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZM3 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZL65 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZL57 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZL39 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZL39EX ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_TOR200 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_TOR300 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_TOR400 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_TOR500 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_ZVL2 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_IORS485 ||
				this.deviceModel.BoardName.toUpperCase() === EBoard.BOARD_ALIAS_RBE4);
		} else {
			return true;
		}
	}

	get commandDescription(): string {
		return (this.deviceStatus) ? this.deviceStatus.CommandDescription : '';
	}

	running(): boolean {
		return typeof this.deviceStatus.Percentage !== 'undefined' && this.deviceStatus.Percentage > 0;
	}
}
